/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { SystemStyleObject } from '@mui/system';

export const globalBreak = ({ mobile, desktop, desktopL, desktopXL }: Record<string, any>): SystemStyleObject => ({
	xs: mobile,
	sm: mobile,
	md: desktop,
	lg:desktopL,
	xl:desktopXL
});

export const literalBreak = ({ xs, sm, md, lg, xl }: Record<string, any>): SystemStyleObject => ({xs, sm, md, lg, xl});
